<template>
    <div class="hero-page">
        <div class="hero-content">
            <div class="limited-width-md">
                <users-auth-register-component></users-auth-register-component>
            </div>

            <div class="col-md-12 d-flex flex-column align-items-center mb-3" v-html="translate.login.registrationJoinNow">
            </div>

            <div class="col-md-12">
                <h2 class="heading-xl text-center mb-4">{{ translate.login.whyRegister }}</h2>
            </div>

            <div class="d-flex flex-column justify-content-center">
                <div class="limited-width-lg">
                    <div class="container my-4">
                        <div class="row">
                            <registration-features-component></registration-features-component>

                            <div class="col-md-12 mt-4">

                                <accordion-component
                                        :content="benefits"
                                        :prefix="'whyRegister'">
                                </accordion-component>

                                <div class="accordion-group">
                                    <div class="accordion">
                                        <div class="accordion-title collapsed"
                                             data-toggle="collapse"
                                             data-target="#benefits2"
                                             aria-controls="benefits2">{{ translate.login.registrationBenefitsListTitle2 }}
                                        </div>
                                        <div class="accordion-content collapse" id="benefits2">
                                            <div v-html="translate.login.registrationBenefitsListContent2"></div>

                                            <div v-if="settings && settings.phone_on_registration_page">
                                                {{ translate.home.tel }} <a :href="`tel:${settings.phone_on_registration_page}`">{{ formatPhoneNumber(settings.phone_on_registration_page) }}</a>
                                            </div>

                                            <a class="green-btn-whatsapp green-btn-whatsapp--max-w-50 mt-2" :href="getWhatsappLink()">
                                                <span class="ml-2 whitespace-nowrap py-2">
                                                    {{ translate.account.needHelp }}
                                                </span>
                                                <IconComponent :icon="fa_whatsapp()" class="fa-whatsapp mx-2"></IconComponent>
                                            </a>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="hero-image"></div>
    </div>
</template>

<script>
import AccordionComponent from "@/components/global/AccordionComponent.vue";
import IconComponent from "@/components/global/IconComponent.vue";
import {getWhatsappLink} from "@/core/utils/helpers/whatsappHelper";
import {formatPhoneNumber} from "@/core/utils/helpers/phoneHelper";
import {fa_whatsapp} from "@/core/constants/icons";

const data = () => {
    return {
        benefits: [
            {
                title: 'login.registrationBenefitsListTitle1',
                content: 'login.registrationBenefitsListContent1',
            },
        ]
    }
}

export default {
    methods: {fa_whatsapp, getWhatsappLink, formatPhoneNumber},
    components: {IconComponent, AccordionComponent},
    data,
    computed: {
        ...mapState(['translate', 'settings']),
    }
}
</script>
